import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { filter, Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { DriftConfiguration } from '../models/configuration.interface';
import { Log } from '../models/prompt-log.interface';

@Injectable({
  providedIn: 'root'
})
export class S3Service {
  config: DriftConfiguration;

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.config = {};

    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  getFiles(type: string, collection_id: string): Observable<Log[]> {
    const params = new HttpParams().set('collection_id', collection_id).set('type', type);
    return this.http.get<Log[]>(`${this.config.driftApi}/logs`, { params });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pollResult(filename: string): Observable<any> {
    const requestBody = { filename };
    return this.http.post(`${this.config.driftApi}/poll-result`, requestBody, {
      observe: 'response'
    });
  }
}
